module.exports = __webpack_public_path__ + "img/priority.83b18f04.png";